var map = {
	"./r1.png": "3DWR",
	"./r2.png": "TfQZ",
	"./r3.png": "sb1O",
	"./r4.png": "OvFI",
	"./r5.png": "AISV",
	"./r6.png": "/HM9",
	"./rengongshenhe.png": "lLm0",
	"./rgNoPass.png": "5NiQ",
	"./rgPass.png": "4Gz5",
	"./rs.png": "7Huk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "J4/i";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image ^\.\/r.*\.png$
// module id = J4/i
// module chunks = 0